import React from 'react';

interface CareProfileGradientButtonProps {
	onClick: () => void;
	children: React.ReactNode;
	id?: string;
	className?: string;
	icon?: React.ReactNode;
	rounded?: string;
}

const CareProfileGradientButton: React.FC<CareProfileGradientButtonProps> = ({ onClick, children, id, className = '', icon, rounded = 'rounded-full' }) => (
	<button
		id={id}
		type="button"
		onClick={onClick}
		className={`w-full bg-care-plus-button-gradient hover:bg-care-plus-button-gradient-hover text-white font-medium py-3 px-6 transition-all duration-200 flex items-center justify-center gap-x-2 border-none cursor-pointer ${rounded} ${className}`}
	>
		{icon}
		{children}
	</button>
);

export default CareProfileGradientButton;
